import { defineComponent, createBlock, openBlock, unref, withCtx, renderSlot, createTextVNode, createElementVNode } from "vue";
import { ScalarSearchResultItem } from "@scalar/components";
const _hoisted_1 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TypesenseSearchResult",
  props: {
    snippet: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(ScalarSearchResultItem), { icon: "DocsPage" }, {
        description: withCtx(() => [
          _cache[0] || (_cache[0] = createTextVNode(" …")),
          createElementVNode("span", {
            class: "guides-search-results-snippet",
            innerHTML: _ctx.snippet
          }, null, 8, _hoisted_1),
          _cache[1] || (_cache[1] = createTextVNode("… "))
        ]),
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TypesenseSearchResult.vue2.js.map
